export const PANEL_WIDTH = 362

export interface Colors {
  [key: string]: string
}

//APP ENV
export const APP_ENV_PRODUCTION_LIST = ['prd', 'production']

// List of all possible shades in order
export const SHADE_ORDER = [
  'c000',
  'c050',
  'c100',
  'c200',
  'c300',
  'c400',
  'c500',
  'c600',
  'c700',
  'c800',
  'c900',
  'c950',
  'c999',
  'transparent'
]

export const EXCEPTIONAL_SHADES = ['c000', 'c999', 'transparent']

export const STANDARD_SHADES = SHADE_ORDER.filter(
  shade => !EXCEPTIONAL_SHADES.includes(shade)
)
